import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PhotoDetail } from '../components/PhotoDetail';
import { photos } from '../data/photos';
export function PhotoPage() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const photo = photos.find(p => p.id === id);
  useEffect(() => {
    if (photo) {
      document.title = `${photo.title} | Alejandro Noriega`;
    } else {
      document.title = 'Photo Not Found | Alejandro Noriega';
    }
    // Scroll to top on mount
    window.scrollTo(0, 0);
  }, [photo]);
  if (!photo) {
    return <div className="min-h-screen bg-offwhite flex flex-col" data-id="element-255">
        <Navbar data-id="element-256" />
        <div className="flex-1 flex flex-col items-center justify-center text-center px-6" data-id="element-257">
          <h1 className="text-4xl font-serif text-charcoal mb-4" data-id="element-258">
            Artwork Not Found
          </h1>
          <p className="text-gray-500 font-sans mb-8" data-id="element-259">
            The photograph you are looking for does not exist or has been
            removed.
          </p>
          <button onClick={() => navigate('/')} className="border border-charcoal text-charcoal px-8 py-3 text-xs font-medium tracking-[0.2em] uppercase transition-all hover:bg-charcoal hover:text-white" data-id="element-260">
            Return to Gallery
          </button>
        </div>
        <Footer data-id="element-261" />
      </div>;
  }
  return <div className="min-h-screen bg-white" data-id="element-262">
      <Navbar data-id="element-263" />
      <main data-id="element-264">
        <PhotoDetail photo={photo} isModal={false} data-id="element-265" />
      </main>
      <Footer data-id="element-266" />
    </div>;
}